function ContentGridSkelton() {
  return (
    <div className="grid grid-cols-1 gap-x-5 gap-y-10 px-10 md:grid-cols-2 xl:grid-cols-4">
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
      <div className="h-96 w-full animate-pulse rounded-2xl bg-slate-700"></div>
    </div>
  );
}

export default ContentGridSkelton;
